module.exports = __webpack_public_path__ + "img/img23.74c7e858.png";